export enum ActionTypes {
  GetUserProducts = 'getUserProducts',
  GetUserProductsRequest = 'getUserProducts.request',
  GetUserProductsSuccess = 'getUserProducts.success',
  GetUserProductsFailure = 'getUserProducts.failure',
}
